export default __webpack_public_path__ + "static/media/ztbk.30e20666.png";